export const DELIVERY_CLIENT_ID =
  process.env.DELIVERY_CLIENT_ID ||
  "ODExODE4YTUzOGVjNzc2ZDA5OWZmOGE0YTgyMTVhYTNh"
